import Icon from '@/components/ui/AppIcon';

const trustFeatures = [
  {
    id: 'trust_1',
    icon: 'ShieldCheckIcon',
    title: 'Sikker datahåndtering',
    description: 'Enterprise-grade sikkerhed og kryptering af alle data i transit og at rest.',
  },
  {
    id: 'trust_2',
    icon: 'ServerStackIcon',
    title: 'API-first platform',
    description: 'Bygget til integration – nem opsætning med jeres eksisterende systemer via API.',
  },
  {
    id: 'trust_3',
    icon: 'ArrowPathIcon',
    title: 'Skalerbar arkitektur',
    description: 'Platformen skalerer med jeres behov – fra få hundrede til tusindvis af dokumenter.',
  },
  {
    id: 'trust_4',
    icon: 'PuzzlePieceIcon',
    title: 'Klar til integration',
    description: 'Forbind nemt til ERP, CRM og andre systemer via vores åbne API og webhooks.',
  },
  {
    id: 'trust_5',
    icon: 'DocumentCheckIcon',
    title: 'GDPR compliant',
    description: 'Fuld overholdelse af GDPR og internationale databeskyttelsesregler.',
  },
  {
    id: 'trust_6',
    icon: 'ClockIcon',
    title: '99.9% oppetid',
    description: 'Redundant infrastruktur med automatisk failover og backup.',
  },
];

export default function TrustSection() {
  return (
    <section className="py-24 px-6 md:px-12 border-b border-border relative z-10">
      <div className="max-w-7xl mx-auto">
        <div className="mb-16 text-center reveal">
          <span className="text-xs font-mono uppercase tracking-widest text-muted-foreground block mb-4">
            06B / TRYGHED
          </span>
          <h2 className="text-4xl md:text-6xl text-foreground tracking-tight font-serif font-light mb-4">
            Bygget til virksomheder
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            En platform I kan stole på – med sikkerhed, skalerbarhed og integrationer i fokus.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {trustFeatures.map((feature, index) => (
            <div
              key={feature.id}
              className={`p-8 border border-border rounded-xl bg-card hover:border-primary/30 transition-colors group reveal delay-${(index + 1) * 100}`}
            >
              <div className="w-14 h-14 rounded-lg bg-primary/10 flex items-center justify-center mb-6 group-hover:bg-primary/20 transition-colors">
                <Icon name={feature.icon as any} size={28} className="text-primary" />
              </div>
              <h3 className="text-lg text-foreground font-medium mb-3">{feature.title}</h3>
              <p className="text-sm text-muted-foreground leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 p-6 border border-primary/30 rounded-xl bg-primary/5 flex items-start gap-4 reveal">
          <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center shrink-0 mt-0.5">
            <Icon name="ClockIcon" size={22} className="text-primary" />
          </div>
          <div>
            <h3 className="text-foreground font-medium mb-1">Hurtig onboarding</h3>
            <p className="text-sm text-muted-foreground leading-relaxed">
              En kunde har normalt en gennemsnitlig onboardingtid på maksimalt <span className="text-foreground font-semibold">5 arbejdsdage</span> fra indgåelse af aftale – så I hurtigt er i gang.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
